
import React from 'react';
import { Language } from '../../types';
import { TRANSLATIONS } from '../../constants';

interface ServicesSidebarProps {
  language: Language;
  categories: { id: string; label: string; icon: string }[];
  activeCategory: string;
  isSidebarOpen: boolean;
  onSetActiveCategory: (id: string) => void;
  onOpenPlans: () => void;
}

const ServicesSidebar: React.FC<ServicesSidebarProps> = ({ 
  language, categories, activeCategory, isSidebarOpen, onSetActiveCategory, onOpenPlans 
}) => {
  const t = TRANSLATIONS[language];

  return (
    <aside className={`hidden lg:flex flex-col bg-white dark:bg-[#0f0f13] border-r dark:border-white/5 z-10 shrink-0 transition-all duration-300 overflow-hidden ${isSidebarOpen ? 'w-64' : 'w-0 border-none'}`}>
      <div className="p-6 min-w-[256px]">
        <div className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-4">{t.servicesMode}</div>
        <div className="space-y-1">
          {categories.map(cat => (
            <button
              key={cat.id}
              onClick={() => onSetActiveCategory(cat.id)}
              className={`
                w-full flex items-center gap-3 px-4 py-3 rounded-xl transition-all text-xs font-bold
                ${activeCategory === cat.id 
                  ? 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400' 
                  : 'text-slate-500 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-white/5'}
              `}
            >
              <i className={`fas ${cat.icon} w-5 text-center`}></i>
              {cat.label}
            </button>
          ))}
        </div>
      </div>
      <div className="mt-auto p-6 border-t border-slate-100 dark:border-white/5 min-w-[256px]">
         <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl p-4 text-white">
            <h4 className="font-black text-sm mb-1">{t.upgrade}</h4>
            <button onClick={onOpenPlans} className="w-full py-2 bg-white/20 hover:bg-white/30 rounded-lg text-[10px] font-black backdrop-blur-sm transition-colors mt-2">
              {t.plansTitle}
            </button>
         </div>
      </div>
    </aside>
  );
};
export default ServicesSidebar;
